import { ref as h, onMounted as J, onBeforeUnmount as Q, openBlock as u, createBlock as U, unref as s, withCtx as f, renderSlot as x, computed as w, createElementBlock as b, toDisplayString as M, createCommentVNode as m, watch as K, createVNode as C, createTextVNode as $, createElementVNode as B, normalizeClass as j, createSlots as T, renderList as z, normalizeProps as W, guardReactiveProps as Z, withKeys as X, pushScopeId as _, popScopeId as ee } from "vue";
import { CdrButton as H, CdrBanner as oe, CdrModal as te, CdrText as ae, CdrGrid as ne, IconFindLocation as le, CdrSelect as ie, CdrImg as de, CdrLink as N } from "@rei/cedar";
import "core-js/modules/es.array.push.js";
import se from "@rei/autocomplete";
import q from "array-find";
const ue = {
  name: "GeolocateButton"
}, ce = /* @__PURE__ */ Object.assign(ue, {
  props: {
    googleApiKey: {
      type: String,
      required: !0
    },
    googleAddressComponent: {
      type: String,
      default: null
    },
    modifier: {
      type: String,
      default: "secondary"
    },
    /**
     * A valid HTML id to assign to the google script
     */
    scriptId: {
      type: String,
      default: "geocode-script"
    }
  },
  emits: ["geolocation-status", "geocoded-geolocation", "geolocation-button", "geolocation"],
  setup(e, {
    emit: o
  }) {
    const a = e, l = h(null);
    J(() => {
      if (document.querySelector(`head > #${a.scriptId}`))
        c();
      else {
        const d = a.googleApiKey, i = document.createElement("script");
        i.id = a.scriptId, i.src = `https://maps.googleapis.com/maps/api/js?key=${d}&callback=initGeocoder&v=weekly`, i.async = !0, i.defer = !0, document.querySelector("head").appendChild(i), window.initGeocoder = c;
      }
    }), Q(() => delete window.initGeocoder);
    function c() {
      l.value = window && window.google && window.google.maps && new window.google.maps.Geocoder();
    }
    async function v(y) {
      var i;
      const d = await ((i = l.value) == null ? void 0 : i.geocode({
        location: y
      }));
      d && d.results ? r(d.results) : o("geolocation-status", "error");
    }
    function r(y) {
      if (a.googleAddressComponent) {
        const d = q(y, (i) => (i.types || []).indexOf(a.googleAddressComponent) > -1);
        if (d) {
          const i = q(d.address_components, (g) => g.types.indexOf(a.googleAddressComponent) > -1);
          if (i) {
            const g = i.short_name;
            g ? (o("geocoded-geolocation", g, d), o("geolocation-status", "allowed")) : o("geolocation-status", "error");
          } else
            o("geolocation-status", "error");
        } else
          o("geolocation-status", "error");
      } else {
        const d = q(y, (i) => (i.types || []).indexOf("locality") > -1);
        if (d) {
          const i = d.formatted_address;
          i ? (o("geocoded-geolocation", i, d), o("geolocation-status", "allowed")) : o("geolocation-status", "error");
        } else
          o("geolocation-status", "error");
      }
    }
    function I(y) {
      const d = !!window.MSInputMethodContext && !!document.documentMode, i = {
        timeout: 15e3,
        enableHighAccuracy: !d,
        maximumAge: d ? 6e4 : 0
      };
      o("geolocation-button", y), "geolocation" in navigator ? (o("geolocation-status", "determining"), navigator.geolocation.getCurrentPosition(async ({
        coords: {
          latitude: g,
          longitude: A,
          altitude: k,
          altitudeAccuracy: L,
          accuracy: O
        }
      }) => {
        if (a.googleApiKey)
          await v({
            lat: g,
            lng: A
          });
        else {
          const V = {
            latitude: g,
            longitude: A,
            altitude: k,
            altitudeAccuracy: L,
            accuracyMeters: O
          };
          o("geolocation-status", "allowed"), o("geolocation", V);
        }
      }, (g) => {
        g.code === g.PERMISSION_DENIED && o("geolocation-status", "blocked");
      }, i)) : o("geolocation-status", "unavailable");
    }
    return (y, d) => (u(), U(s(H), {
      modifier: e.modifier,
      "icon-only": !0,
      onClick: I
    }, {
      default: f(() => [x(y.$slots, "default")]),
      _: 3
    }, 8, ["modifier"]));
  }
}), re = {
  key: 0
}, ge = {
  key: 1
}, me = {
  key: 2
}, pe = {
  key: 3
}, fe = {
  key: 4
}, ye = {
  name: "StatusMessages"
}, ve = /* @__PURE__ */ Object.assign(ye, {
  props: {
    status: {
      type: String,
      default: void 0
    },
    messageGeolocationBlocked: {
      type: String,
      default: "Geo-location services must be enabled in your browser settings to use this feature"
    },
    messageGeolocationUnavailable: {
      type: String,
      default: "Your browser does not support finding your location"
    },
    messageGeolocationError: {
      type: String,
      default: "Sorry, we could not resolve your location"
    },
    messageGeolocationDetermining: {
      type: String,
      default: "Determining your location..."
    },
    messageInputInvalid: {
      type: String,
      default: "Enter a ZIP code or City, State"
    }
  },
  setup(e) {
    const o = e, a = h(["blocked", "unavailable", "determining", "error", "invalid"]), l = w(() => a.value.indexOf(o.status) > -1), c = w(() => o.status === "determining" ? "warning" : "error");
    return (v, r) => s(l) ? (u(), U(s(oe), {
      key: 0,
      class: "status-messages",
      type: s(c)
    }, {
      default: f(() => [e.status === "blocked" ? (u(), b("span", re, M(e.messageGeolocationBlocked), 1)) : m("", !0), e.status === "unavailable" ? (u(), b("span", ge, M(e.messageGeolocationUnavailable), 1)) : m("", !0), e.status === "error" ? (u(), b("span", me, M(e.messageGeolocationError), 1)) : m("", !0), e.status === "determining" ? (u(), b("span", pe, M(e.messageGeolocationDetermining), 1)) : m("", !0), e.status === "invalid" ? (u(), b("span", fe, M(e.messageInputInvalid), 1)) : m("", !0)]),
      _: 1
    }, 8, ["type"])) : m("", !0);
  }
});
const he = (e, o) => {
  const a = e.__vccOpts || e;
  for (const [l, c] of o)
    a[l] = c;
  return a;
}, be = (e) => (_("data-v-dc254721"), e = e(), ee(), e), Se = {
  class: "modal-style-scope"
}, Ge = {
  class: "location-search-modal__fields"
}, Ce = {
  class: "autocomplete-wrapper relative",
  "aria-live": "polite"
}, Me = /* @__PURE__ */ be(() => /* @__PURE__ */ B("span", {
  class: "sr-only"
}, "Find my location", -1)), Ue = {
  name: "LocationModal"
}, ke = /* @__PURE__ */ Object.assign(Ue, {
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    radius: {
      type: Number,
      default: 100
    },
    modalOpen: {
      type: Boolean,
      default: !1
    },
    radiusOptions: {
      type: Array,
      default: () => [25, 50, 100, 150, 200]
    },
    placeholder: {
      type: String,
      default: void 0
    },
    suggestions: {
      type: Array,
      default: () => []
    },
    maxSuggestions: {
      type: Number,
      required: !1,
      default: 5
    },
    autocompleteFetchUrl: {
      type: [String, Function],
      default: void 0
    },
    autocompleteMatchProperty: {
      type: String,
      required: !1,
      default: "description"
    },
    autocompleteDelay: {
      type: Number,
      default: 100
    },
    disableGeolocate: {
      type: Boolean
    },
    disableRadius: {
      type: Boolean
    },
    dataUiModalInput: {
      type: String,
      default: void 0
    },
    dataUiModalGeolocateBtn: {
      type: String,
      default: void 0
    },
    dataUiModalUpdateBtn: {
      type: String,
      default: void 0
    },
    dataUiModalMobileCancelBtn: {
      type: String,
      default: void 0
    },
    dataUiModalCloseModalBtn: {
      type: String,
      default: void 0
    },
    dataUiModalRadiusSelect: {
      type: String,
      default: void 0
    },
    googleApiKey: {
      type: String,
      required: !0
    },
    googleAddressComponent: {
      type: String,
      default: void 0
    },
    validation: {
      type: Boolean,
      default: !1
    },
    validationPattern: {
      type: RegExp,
      // Limits the following characters from being entered
      // = + * ! " { } [ ] < > ; $ @ / \ ? %
      default: () => /^[^=+*!"{}[\]<>;$@/\\?%]*$/
    },
    messageInputInvalid: {
      type: String,
      default: void 0
    },
    messageGeolocationError: {
      type: String,
      default: void 0
    },
    messageGeolocationBlocked: {
      type: String,
      default: void 0
    },
    messageGeolocationDetermining: {
      type: String,
      default: void 0
    },
    messageGeolocationUnavailable: {
      type: String,
      default: void 0
    },
    /**
     * A valid HTML id to assign to the google script
     */
    scriptId: {
      type: String,
      default: "geocode-script"
    }
  },
  emits: ["close-modal", "update-location", "radius-change", "autocomplete-selected-data", "autocomplete-input-mutated", "autocomplete-change", "autocomplete-focus", "geolocation", "geocoded-geolocation", "geolocation-status", "geolocate-button"],
  setup(e, {
    emit: o
  }) {
    const a = e, l = h(a.modelValue), c = h(a.radius), v = h(null), r = h(null), I = h(null), y = w(() => `location-search-modal__grid stack ${a.disableRadius ? "location-search-modal--hide-radius" : ""}`), d = w(() => {
      if (!(a.radiusOptions.indexOf(parseInt(c.value, 10)) > -1)) {
        const t = (G, D) => G - D, p = a.radiusOptions.slice(0, a.radiusOptions.length);
        return p.push(c.value), p.sort(t), p;
      }
      return a.radiusOptions;
    }), i = w(() => d.value.map((t) => ({
      text: `Within ${t} miles`,
      value: t
    }))), g = w(() => {
      const t = l.value.replace(/\s/g, "");
      return t.length === 0 ? !1 : a.validationPattern.test(t);
    });
    K(() => a.modelValue, (t) => {
      l.value = t;
    });
    function A() {
      l.value = a.modelValue, c.value = a.radius, v.value = null, r.value = null, o("close-modal");
    }
    function k() {
      a.validation === !1 || g.value ? (l.value.replace(/\s/g, "").length > 0 && o("update-location", l.value, c.value, v.value), r.value = null, o("close-modal")) : r.value = "invalid";
    }
    function L() {
      r.value = null, o("radius-change", c.value);
    }
    function O(t) {
      v.value = t, o("autocomplete-selected-data", t);
    }
    function V() {
      v.value = null, o("autocomplete-input-mutated");
    }
    function E(t) {
      l.value = t, o("autocomplete-change", t);
    }
    function R(t) {
      I.value = t, r.value = null, o("autocomplete-focus", t);
    }
    function P(t) {
      o("geolocation", t);
    }
    function F(t, p) {
      l.value = t, v.value = p, o("geocoded-geolocation", t, p);
    }
    function n(t) {
      r.value = t, o("geolocation-status", t);
    }
    function S(t) {
      o("geolocate-button", t);
    }
    return (t, p) => (u(), b("div", Se, [C(s(te), {
      opened: e.modalOpen,
      label: "Find a Location",
      "wrapper-class": "location-search-modal__wrapper",
      "overlay-class": "location-search-modal__overlay",
      "content-class": "location-search-modal__content",
      onClosed: A
    }, {
      title: f(() => [C(s(ae), {
        tag: "h1",
        class: "location-search-modal__heading"
      }, {
        default: f(() => [$(" Change your location ")]),
        _: 1
      })]),
      default: f(() => [B("div", Ge, [C(s(ne), {
        gutter: "none",
        class: j(s(y))
      }, {
        default: f(() => [B("div", Ce, [C(s(se), {
          modelValue: l.value,
          "onUpdate:modelValue": p[0] || (p[0] = (G) => l.value = G),
          class: j({
            "location-search-modal__left-input": !e.disableGeolocate
          }),
          label: "Location",
          "aria-label": "Enter your location",
          type: "text",
          placeholder: e.placeholder,
          autocomplete: "street-address",
          "data-ui": e.dataUiModalInput,
          suggestions: e.suggestions,
          "max-suggestions": e.maxSuggestions,
          "fetch-url": e.autocompleteFetchUrl,
          "match-property": e.autocompleteMatchProperty,
          delay: e.autocompleteDelay,
          onAutocompleteFocus: R,
          onAutocompleteChange: E,
          onAutocompleteSelectedData: O,
          onClearAutocompleteSelection: V,
          onAutocompleteSubmit: k
        }, T({
          "post-icon": f(() => [e.disableGeolocate ? m("", !0) : (u(), U(s(ce), {
            key: 0,
            class: "geolocate-btn location-search-modal__right-icon",
            modifier: "secondary",
            "google-api-key": e.googleApiKey,
            disabled: r.value === "unavailable" || r.value === "determining",
            "data-ui": e.dataUiModalGeolocateBtn,
            "google-address-component": e.googleAddressComponent,
            "script-id": e.scriptId,
            onGeolocationStatus: n,
            onGeocodedGeolocation: F,
            onGeolocation: P,
            onGeolocationButton: S
          }, {
            default: f(() => [C(s(le), {
              focusable: "false",
              class: "icon_geolocate"
            }), Me]),
            _: 1
          }, 8, ["google-api-key", "disabled", "data-ui", "google-address-component", "script-id"]))]),
          _: 2
        }, [z(t.$slots, (G, D) => ({
          name: D,
          fn: f((Y) => [x(t.$slots, D, W(Z(Y)), void 0, !0)])
        }))]), 1032, ["modelValue", "class", "placeholder", "data-ui", "suggestions", "max-suggestions", "fetch-url", "match-property", "delay"]), !I.value || !s(g) ? (u(), U(ve, {
          key: 0,
          "message-input-invalid": e.messageInputInvalid,
          "message-geolocation-error": e.messageGeolocationError,
          "message-geolocation-blocked": e.messageGeolocationBlocked,
          "message-geolocation-unavailable": e.messageGeolocationUnavailable,
          "message-geolocation-determining": e.messageGeolocationDetermining,
          status: r.value
        }, null, 8, ["message-input-invalid", "message-geolocation-error", "message-geolocation-blocked", "message-geolocation-unavailable", "message-geolocation-determining", "status"])) : m("", !0)]), e.disableRadius ? m("", !0) : (u(), U(s(ie), {
          key: 0,
          modelValue: c.value,
          "onUpdate:modelValue": p[1] || (p[1] = (G) => c.value = G),
          label: "Distance",
          "aria-label": "Miles to search from location",
          class: "radius-select relative",
          "data-ui": e.dataUiModalRadiusSelect,
          options: s(i),
          onChange: L,
          onKeyup: X(k, ["enter"])
        }, null, 8, ["modelValue", "data-ui", "options", "onKeyup"])), C(s(H), {
          class: "location-search-modal__update-btn",
          "data-ui": e.dataUiModalUpdateBtn,
          "full-width": !0,
          onClick: k
        }, {
          default: f(() => [$(" Update ")]),
          _: 1
        }, 8, ["data-ui"])]),
        _: 3
      }, 8, ["class"])])]),
      _: 3
    }, 8, ["opened"]), e.modalOpen ? (u(), U(s(de), {
      key: 0,
      src: "https://satchel.rei.com/media/img/powered_by_google_on_white.png",
      alt: "Powered by Google",
      class: "location-search-modal__google-attribution"
    })) : m("", !0)]));
  }
}), Be = /* @__PURE__ */ he(ke, [["__scopeId", "data-v-dc254721"]]), Ie = {
  "data-ui": "no-label-slot",
  class: "location-search-modal__facet-title"
}, Ae = {
  key: 0
}, we = ["data-ui"], $e = ["data-ui"], Le = {
  "data-ui": "no-radius-slot"
}, Oe = {
  key: 2
}, Ve = {
  name: "LocationSearch"
}, Fe = /* @__PURE__ */ Object.assign(Ve, {
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    displayedValue: {
      type: String,
      default: ""
    },
    radius: {
      type: Number,
      default: 100
    },
    modalOpen: {
      type: Boolean,
      default: !1
    },
    label: {
      type: String,
      default: "Location"
    },
    placeholder: {
      type: String,
      default: "City, State or Zip"
    },
    suggestions: {
      type: Array,
      default: () => []
    },
    maxSuggestions: {
      type: Number,
      required: !1,
      default: 5
    },
    autocompleteFetchUrl: {
      type: [String, Function],
      default: void 0
    },
    autocompleteMatchProperty: {
      type: String,
      required: !1,
      default: "description"
    },
    autocompleteDelay: {
      type: Number,
      required: !1,
      default: 100
    },
    radiusOptions: {
      type: Array,
      default: () => [25, 50, 100, 150, 200]
    },
    disableGeolocate: {
      type: Boolean
    },
    disableRadius: {
      type: Boolean
    },
    dataUiSearchedLocation: {
      type: String,
      default: void 0
    },
    dataUiSearchedRadius: {
      type: String,
      default: void 0
    },
    dataUiAddLocationBtn: {
      type: String,
      default: void 0
    },
    dataUiChangeLocationBtn: {
      type: String,
      default: void 0
    },
    dataUiModalInput: {
      type: String,
      default: void 0
    },
    dataUiModalGeolocateBtn: {
      type: String,
      default: void 0
    },
    dataUiModalUpdateBtn: {
      type: String,
      default: void 0
    },
    dataUiModalMobileCancelBtn: {
      type: String,
      default: void 0
    },
    dataUiModalCloseModalBtn: {
      type: String,
      default: void 0
    },
    dataUiModalRadiusSelect: {
      type: String,
      default: void 0
    },
    removeLocationEnabled: {
      type: Boolean,
      required: !1
    },
    googleApiKey: {
      type: String,
      required: !0
    },
    googleAddressComponent: {
      type: String,
      default: void 0
    },
    validation: {
      type: Boolean,
      default: !1
    },
    validationPattern: {
      type: RegExp,
      default: void 0
    },
    messageInputInvalid: {
      type: String,
      default: void 0
    },
    messageGeolocationError: {
      type: String,
      default: void 0
    },
    messageGeolocationBlocked: {
      type: String,
      default: void 0
    },
    messageGeolocationDetermining: {
      type: String,
      default: void 0
    },
    messageGeolocationUnavailable: {
      type: String,
      default: void 0
    },
    /**
     * A valid HTML id to assign to the google script
     */
    scriptId: {
      type: String,
      default: "geocode-script"
    }
  },
  emits: ["location-search", "open-modal", "close-modal", "add-location", "change-location", "update-location", "radius-change", "remove-location", "geolocation", "geocoded-geolocation", "geolocation-status", "geolocate-button", "autocomplete-selected-data", "autocomplete-input-mutated", "autocomplete-change", "autocomplete-focus"],
  setup(e, {
    emit: o
  }) {
    const a = e, l = h(a.modelValue), c = h(a.displayedValue), v = h(a.modalOpen);
    K(() => a.modelValue, (n) => {
      l.value = n, o("location-search", n);
    }), K(() => a.displayedValue, (n) => {
      c.value = n;
    });
    function r() {
      v.value = !0, o("open-modal");
    }
    function I() {
      v.value = !1, o("close-modal");
    }
    function y() {
      r(), o("add-location");
    }
    function d() {
      r(), o("change-location");
    }
    function i(n, S, t) {
      o("update-location", n, S, t);
    }
    function g(n) {
      o("radius-change", n);
    }
    function A() {
      o("remove-location");
    }
    function k(n) {
      o("geolocation", n);
    }
    function L(n, S) {
      o("geocoded-geolocation", n, S);
    }
    function O(n) {
      o("geolocation-status", n);
    }
    function V(n) {
      o("geolocate-button", n);
    }
    function E(n) {
      o("autocomplete-selected-data", n);
    }
    function R() {
      o("autocomplete-input-mutated");
    }
    function P(n) {
      o("autocomplete-change", n);
    }
    function F(n) {
      o("autocomplete-focus", n);
    }
    return (n, S) => (u(), b("div", null, [x(n.$slots, "label", {
      label: e.label
    }, () => [B("div", Ie, M(e.label), 1)]), l.value ? (u(), b("div", Ae, [B("span", {
      "data-ui": e.dataUiSearchedLocation,
      class: "location-search-modal__facet-location"
    }, M(c.value || l.value), 9, we), e.radius ? (u(), b("div", {
      key: 0,
      "data-ui": e.dataUiSearchedRadius
    }, [x(n.$slots, "radius", {
      radius: e.radius
    }, () => [B("span", Le, " Within " + M(e.radius) + " miles ", 1)])], 8, $e)) : m("", !0)])) : m("", !0), B("div", null, [l.value ? (u(), U(s(N), {
      key: 0,
      tag: "button",
      modifier: "standalone",
      "aria-haspopup": "dialog",
      "data-ui": e.dataUiChangeLocationBtn,
      onClick: d
    }, {
      default: f(() => [$(" Change location ")]),
      _: 1
    }, 8, ["data-ui"])) : m("", !0), l.value ? m("", !0) : (u(), U(s(N), {
      key: 1,
      tag: "button",
      modifier: "standalone",
      "aria-haspopup": "dialog",
      "data-ui": e.dataUiAddLocationBtn,
      onClick: y
    }, {
      default: f(() => [$(" Add a location ")]),
      _: 1
    }, 8, ["data-ui"])), l.value && e.removeLocationEnabled ? (u(), b("span", Oe, [$(" • "), C(s(N), {
      tag: "button",
      modifier: "standalone",
      "data-ui": "location-facet-remove-btn",
      "aria-label": "Remove location",
      onClick: A
    }, {
      default: f(() => [$(" Remove ")]),
      _: 1
    })])) : m("", !0)]), C(Be, {
      modelValue: l.value,
      "onUpdate:modelValue": S[0] || (S[0] = (t) => l.value = t),
      radius: e.radius,
      "modal-open": v.value,
      placeholder: e.placeholder,
      suggestions: e.suggestions,
      "max-suggestions": e.maxSuggestions,
      "autocomplete-fetch-url": e.autocompleteFetchUrl,
      "autocomplete-match-property": e.autocompleteMatchProperty,
      "autocomplete-delay": e.autocompleteDelay,
      "radius-options": e.radiusOptions,
      "google-api-key": e.googleApiKey,
      "google-address-component": e.googleAddressComponent,
      "disable-geolocate": e.disableGeolocate,
      "disable-radius": e.disableRadius,
      validation: e.validation,
      "validation-pattern": e.validationPattern,
      "message-input-invalid": e.messageInputInvalid,
      "message-geolocation-error": e.messageGeolocationError,
      "message-geolocation-blocked": e.messageGeolocationBlocked,
      "message-geolocation-unavailable": e.messageGeolocationUnavailable,
      "message-geolocation-determining": e.messageGeolocationDetermining,
      "data-ui-modal-input": e.dataUiModalInput,
      "data-ui-modal-geolocate-btn": e.dataUiModalGeolocateBtn,
      "data-ui-modal-update-btn": e.dataUiModalUpdateBtn,
      "data-ui-modal-mobile-cancel-btn": e.dataUiModalMobileCancelBtn,
      "data-ui-modal-close-modal-btn": e.dataUiModalCloseModalBtn,
      "data-ui-modal-radius-select": e.dataUiModalRadiusSelect,
      "script-id": e.scriptId,
      onOpenModal: r,
      onCloseModal: I,
      onUpdateLocation: i,
      onRadiusChange: g,
      onGeocodedGeolocation: L,
      onGeolocation: k,
      onGeolocationStatus: O,
      onGeolocateButton: V,
      onAutocompleteSelectedData: E,
      onAutocompleteChange: P,
      onAutocompleteFocus: F,
      onAutocompleteInputMutated: R
    }, T({
      _: 2
    }, [z(n.$slots, (t, p) => ({
      name: p,
      fn: f((G) => [x(n.$slots, p, W(Z(G)))])
    }))]), 1032, ["modelValue", "radius", "modal-open", "placeholder", "suggestions", "max-suggestions", "autocomplete-fetch-url", "autocomplete-match-property", "autocomplete-delay", "radius-options", "google-api-key", "google-address-component", "disable-geolocate", "disable-radius", "validation", "validation-pattern", "message-input-invalid", "message-geolocation-error", "message-geolocation-blocked", "message-geolocation-unavailable", "message-geolocation-determining", "data-ui-modal-input", "data-ui-modal-geolocate-btn", "data-ui-modal-update-btn", "data-ui-modal-mobile-cancel-btn", "data-ui-modal-close-modal-btn", "data-ui-modal-radius-select", "script-id"])]));
  }
});
export {
  ce as GeolocateButton,
  Be as LocationModal,
  Fe as LocationSearch,
  Fe as default
};
